module.exports = __webpack_public_path__ + "static/media/score_result_1.998ecc41.png";